<template>
    <div>
        <SearchObject
            :additional-params="{ ...additionalParams }"
            :allow-create="allowCreate"
            :autofocus="autofocus"
            :base-url="baseUrl"
            :create-label="$translate('create_a_catalog')"
            :disabled="disabled"
            :hide-details="hideDetails"
            :item-text="itemText"
            :label="label || $translate('select_catalog')"
            :readonly="readonly"
            :required="required"
            :value="value"
            :initial-item="initialItem"
            @create="createcatalog"
            @input="onSearchInput"
            @select="$emit('select', $event)"
            display="catalog"
            ref="search"
            :dense="dense"
            :outlined="outlined"
            :error-messages="errorMessages"
        >
        </SearchObject>
    </div>
</template>

<script>
import EditCatalog from "@/modals/catalog";
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    name: "Searchcatalog",
    props: {
        // The base URL to fetch items from.
        baseUrl: {
            type: String,
            default: "/api/catalogs/",
        },
        // Additional GET parameters to include in the API request.
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        // Whether the component is disabled.
        disabled: {
            type: Boolean,
            default: false,
        },
        // v-model binding (selected item ID).
        value: {
            type: [String, Number],
            default: null,
        },
        initialItem: {
            type: Object,
            default: null,
        },
        // Label for the autocomplete.
        label: {
            type: String,
            required: false,
        },
        // Optional limit per request.
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        allowCreate: {
            type: Boolean,
            default: false,
        },
        createModalParams: {
            type: Object,
            default: () => ({}),
        },
        createCatalogDefaults: {
            type: Object,
            default: () => ({}),
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: null,
        },
    },
    methods: {
        onSearchInput(val) {
            if (val == null || val === "") {
                this.$emit("input", null);
                return;
            }
            const id = typeof val === "object" && val !== null ? val.id : val;
            this.$emit("input", id);
        },
        async createcatalog() {
            const result = await this.showModal({
                component: EditCatalog,
                params: {
                    ...this.createModalParams,
                    catalog: {
                        ...this.createCatalogDefaults,
                    },
                },
            });
            if (result) {
                this.onSearchInput(result.id ?? result);
                this.$refs.search.update();
            } else {
                this.$refs.search.reset();
            }
        },
        itemText(item) {
            if (item.id === 'new') {
                return item.name;
            }
            let text = item.name;
            if (item.provider_data) {
                text = `${item.provider_data?.name} - ${item.name}`;
            }
            if (item.archived) {
                text = `${text} - ${this.$translate("archived")}`;
            }
            return text;
        },
        focus() {
            this.$refs.search.focus();
        },
    },
    i18n: {
        messages: {
            en: {
                select_catalog: "Select a catalog",
                create_a_catalog: "Create a catalog",
                archived: "Archived",
            },
            fr: {
                select_catalog: "Sélectionnez un catalogue",
                create_a_catalog: "Créer un catalogue",
                archived: "Archivé",
            },
        },
    },
};
</script>
